import { PersonPassportSeriesNumber } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useValidatePassportLinkedFieldsOnBlur } from '../../lib/useValidatePassportLinkedFieldsOnBlur';

export const PassportSeriesNumber: FC<IFieldFactoryProps> = (props) => {
  const { type } = props;
  const validate = useValidatePassportLinkedFieldsOnBlur(type);

  return (
    <div onBlur={validate}>
      <PersonPassportSeriesNumber {...props} />
    </div>
  );
};
